module.exports = __webpack_public_path__ + "img/img36.8b207936.png";